import {copilot, users as usersShared} from '@cl/shared';
import adBuilderAgent from 'common/src/modules/creativeTemplates/copilot/agents/adBuilderAgent/adBuilderAgent';
import creativeTemplatesManagerAgent from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/creativeTemplatesManagerAgent';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';

function initializeCreativeTemplatesAgents(store: CLStore) {
  copilot.registerAgent(creativeTemplatesManagerAgent(store));

  const userHasTemplateWriteRole = doesUserHaveRole(
    usersShared.userSubject.data,
    RoleTypeName.CreativeTemplatesWrite,
  );

  if (isFlagEnabled(FeatureFlagKey.EnableCopilotAdBuilderAgent) && userHasTemplateWriteRole) {
    copilot.registerAgent(adBuilderAgent(store));
  }
}

export default initializeCreativeTemplatesAgents;
